import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { GetActiveProductsDocument } from "graphql/generated";
import graphQLClient from "graphql/react-query";
import { activeProductsState, isFetchingActiveProductsState, patientState } from "src/states";

const useFetchActiveProducts = () => {
  const [activeProducts, setActiveProducts] = useRecoilState(activeProductsState);
  const [isFetching, setIsFetching] = useRecoilState(isFetchingActiveProductsState);
  const patient = useRecoilValue(patientState);

  useEffect(() => {
    if (!patient) {
      setIsFetching(false);
      return;
    }

    const fetchCurrentSub = async () => {
      try {
        setIsFetching(true);

        const activeProductData = await graphQLClient.request(GetActiveProductsDocument, {
          input: {}
        });

        setActiveProducts(activeProductData.getActiveProducts);

        setIsFetching(false);
      } catch (e) {
        throw new Error("Cannot get active products");
      } finally {
        setIsFetching(false);
      }
    };

    fetchCurrentSub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient]);

  return { activeProducts, isFetching };
};

export default useFetchActiveProducts;
